import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { directionsFilterFields } from "./fields";

const DirectionsFilter = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => directionsFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};

export default DirectionsFilter;
